import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom';
import AuthContext from '../AuthContext';

function Header() {
	const navigate = useNavigate();
	const { logout } = useContext(AuthContext);

	const handleLogout = () => {
		logout()
		navigate('/login'); // Redirect to login page after logout
	};
	return (
		<div className="header header-one">
			<a href="index.html" className="d-inline-flex d-sm-inline-flex align-items-center d-md-inline-flex d-lg-none align-items-center device-logo">
				<img src="assets/img/logo-uh.png" className="img-fluid logo2" alt="Logo" />
			</a>
			<div className="main-logo d-inline float-start d-lg-flex align-items-center d-none d-sm-none d-md-none">
				<div className="logo-white">
					<a href="index.html">
						<img src="assets/img/logo-full-white.png" className="img-fluid logo-blue" alt="Logo" />
					</a>
					<a href="index.html">
						<img src="assets/img/logo-small-white.png" className="img-fluid logo-small" alt="Logo" />
					</a>
				</div>
				<div className="logo-color">
					<a href="index.html">
						<img src="assets/img/logo-uh.png" className="img-fluid logo-blue" alt="Logo" />
					</a>
					<a href="index.html">
						<img src="assets/img/logo-small-uh.png" className="img-fluid logo-small" alt="Logo" />
					</a>
				</div>
			</div>
			{/* Sidebar Toggle */}
			<a href="#" id="toggle_btn" onClick={(e) => e.preventDefault()}>
				<span className="toggle-bars">
					<span className="bar-icons"></span>
					<span className="bar-icons"></span>
					<span className="bar-icons"></span>
					<span className="bar-icons"></span>
				</span>
			</a>
			{/* Sidebar Toggle */}

			{/* Mobile Menu Toggle */}
			<a className="mobile_btn" id="mobile_btn">
				<i className="fas fa-bars"></i>
			</a>
			{/* Mobile Menu Toggle */}

			{/* Header Menu */}
			<ul className="nav nav-tabs user-menu">

				{/* /Notification */}
				<li className="nav-item dropdown  flag-nav dropdown-heads">
					<a className="nav-link" data-bs-toggle="dropdown" href="#" role="button">
						<i className="fe fe-bell"></i> <span className="badge rounded-pill"></span>
					</a>
					<div className="dropdown-menu notifications">
						<div className="topnav-dropdown-header">
							<div className="notification-title">Notifications <a href="notifications.html">View all</a></div>
							<a href="javascript:void(0)" className="clear-noti d-flex align-items-center">Mark all as read <i className="fe fe-check-circle"></i></a>
						</div>
						<div className="noti-content">
							<ul className="notification-list">
								<li className="notification-message">
									<a href="profile.html">
										<div className="d-flex">
											<span className="avatar avatar-md active">
												<img className="avatar-img rounded-circle" alt="avatar-img" src="assets/img/profiles/avatar-02.jpg" />
											</span>
											<div className="media-body">
												<p className="noti-details"><span className="noti-title">Lex Murphy</span> requested access to <span className="noti-title">UNIX directory tree hierarchy</span></p>
												<div className="notification-btn">
													<span className="btn btn-primary">Accept</span>
													<span className="btn btn-outline-primary">Reject</span>
												</div>
												<p className="noti-time"><span className="notification-time">Today at 9:42 AM</span></p>
											</div>
										</div>
									</a>
								</li>
								<li className="notification-message">
									<a href="profile.html">
										<div className="d-flex">
											<span className="avatar avatar-md active">
												<img className="avatar-img rounded-circle" alt="avatar-img" src="assets/img/profiles/avatar-10.jpg" />
											</span>
											<div className="media-body">
												<p className="noti-details"><span className="noti-title">Ray Arnold</span> left 6 comments <span className="noti-title">on Isla Nublar SOC2 compliance report</span></p>
												<p className="noti-time"><span className="notification-time">Yesterday at 11:42 PM</span></p>
											</div>
										</div>
									</a>
								</li>
								<li className="notification-message">
									<a href="profile.html">
										<div className="d-flex">
											<span className="avatar avatar-md">
												<img className="avatar-img rounded-circle" alt="avatar-img" src="assets/img/profiles/avatar-13.jpg" />
											</span>
											<div className="media-body">
												<p className="noti-details"><span className="noti-title">Dennis Nedry</span> commented on <span className="noti-title"> Isla Nublar SOC2 compliance report</span></p>
												<blockquote>
													“Oh, I finished de-bugging the phones, but the system's compiling for eighteen minutes, or twenty.  So, some minor systems may go on and off for a while.”
												</blockquote>
												<p className="noti-time"><span className="notification-time">Yesterday at 5:42 PM</span></p>
											</div>
										</div>
									</a>
								</li>
								<li className="notification-message">
									<a href="profile.html">
										<div className="d-flex">
											<span className="avatar avatar-md">
												<img className="avatar-img rounded-circle" alt="avatar-img" src="assets/img/profiles/avatar-05.jpg" />
											</span>
											<div className="media-body">
												<p className="noti-details"><span className="noti-title">John Hammond</span> created <span className="noti-title">Isla Nublar SOC2 compliance report</span></p>
												<p className="noti-time"><span className="notification-time">Last Wednesday at 11:15 AM</span></p>
											</div>
										</div>
									</a>
								</li>
							</ul>
						</div>
						<div className="topnav-dropdown-footer">
							<a href="#">Clear All</a>
						</div>
					</div>
				</li>
				<li className="nav-item  has-arrow dropdown-heads ">
					<a href="javascript:void(0);" className="win-maximize">
						<i className="fe fe-maximize"></i>
					</a>
				</li>
				{/* User Menu */}
				<li className="nav-item dropdown">
					<a href="javascript:void(0)" className="user-link  nav-link" data-bs-toggle="dropdown">
						<span className="user-img">
							<img src="assets/img/profiles/avatar-07.jpg" alt="img" className="profilesidebar" />
							<span className="animate-circle"></span>
						</span>
						<span className="user-content">
							<span className="user-details">Admin</span>
							<span className="user-name">John Smith</span>
						</span>
					</a>
					<div className="dropdown-menu menu-drop-user">
						<div className="profilemenu">
							<div className="subscription-menu">
								<ul>
									<li>
										<a className="dropdown-item" href="profile.html">Profile</a>
									</li>
									<li>
										<a className="dropdown-item" href="settings.html">Settings</a>
									</li>
								</ul>
							</div>
							<div className="subscription-logout">
								<ul>
									<li className="pb-0">
										<a className="dropdown-item" onClick={handleLogout}>Log Out</a>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</li>
				{/* User Menu */}

			</ul>

			{/* Header Menu */}

		</div>
	)
}

export default Header